import { useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const useActiveChecksPolling = () => {

      const { user } = useSelector((state) => state.auth);
    
    useEffect(() => {

        if (!user?.stuff) return;

        const fetchChecks = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.post(
                    "https://estbn.com/EstbnNew/public/api/stuff/last-activity",
                    {},
                   {
                     headers: { Authorization: `Bearer ${token}` },
                     }
                );
                console.log("Active Checks:", response.data);
            } catch (error) {
                console.error("Error fetching active checks:", error);
            }
        };
        fetchChecks();
        const interval = setInterval(fetchChecks, 60000);
        return () => clearInterval(interval);
    }, [user]);
};

export default useActiveChecksPolling;